import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { useEffect } from "react";
import ToggleSwitch from "../ReusableComp/ToggleSwitch";
import styles from "../Events.module.css";
import remove from "../../../Icons/Event/remove.png";
import DeleteIcon from "@material-ui/icons/Delete";
import Input from "../ReusableComp/Input";
import datajson from "../data.json";
import { checkValid } from "../../../Resources/globalFunctions";
import Tooltip from "@material-ui/core/Tooltip";
import { useTranslation } from "react-i18next";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector } from "../../../Redux";
import {
  encrypt,
  decryptMessage,
  getFormJsonFromStore,
} from "../../../components/IFormDesignerLayout/IFormDesignerLogic";
import uuid from "react-uuid";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { GetStateFromData } from "../../../components/CustomHooks/CustomHooks";
import downarrow_svg from "../../../Icons/Event/downarrow_svg.svg";
import uparrow_svg from "../../../Icons/Event/uparrow_svg.svg";
import { functions, validateSqlQuery } from "../../../components/IFormDesignerLayout/ApplicationAPI/applicationApi";

const useStyles = makeStyles({
  root: {
    padding: 0,
    margin: "4px",
    border: "1px solid #C4C4C4",
    "& .MuiChip-root": {
      borderRadius: 2,
      width: "90px",
      height: "25px",
      backgroundColor: "#F0F0F0",
    },
    "& .MuiButtonBase-root": {
      margin: "0 !important",
    },
    "& .MuiInputBase-input": {
      border: "none !important",
      flexGrow: "0",
      minWidth: "90px",
    },

    "& .MuiAutocomplete-endAdornment": {
      right:
        window?.psh_configs?.selectedLanguage === "ar" ||
        window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "unset"
          : null,
      left:
        window?.psh_configs?.selectedLanguage === "ar" ||
        window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "-183px"
          : null,
    },
    "& .MuiChip-deleteIcon": {
      marginRight:
        window?.psh_configs?.selectedLanguage === "ar" ||
        window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "unset"
          : null,
      marginLeft:
        window?.psh_configs?.selectedLanguage === "ar" ||
        window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "5px"
          : null,
    },
  },
  inputRoot: {
    "& .MuiOutlinedInput-root": {
      "& .MuiAutocomplete-endAdornment": {
        right:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "unset"
            : null,
        left:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "9px"
            : null,
      },
      "& .MuiAutocomplete-inputRoot": {
        paddingRight: "unset !important",
      },
    },
    "& .MuiAutocomplete-inputRoot": {
      paddingRight: "unset !important",
    },
    "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
  },
  table: {
    minWidth: 650,
  },
  tooltip: {
    maxWidth: "160px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12,
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075",
    },
    color: "white",
    fontSize: 15,
  },
});

const DBLinking = (props) => {
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const contexts = GetStateFromData();
  const gridContexts = GetStateFromData(undefined, "data2");

    const { advanceListviewStateJson } = gridContexts.gridStates;

  const {
    formState2,
    showAlertConfirmNotifications,
    setOpen1,
    setSeverity,
    setSeverityMessage,
    isTaskForm,
    subFormStateJson,
    openCanvasForSubform,
    currentListviewForSubform
  } = contexts.contexts;
  const classes = useStyles();
  const { t } = useTranslation(["styles", "translation"]);
  const [state, setState] = React.useState(props.defaultState || [{}]);
  const [controlList, setControlList] = React.useState([]);
  var arr = [];
  const AddRow = () => {
    setState([...state, {}]);
  };
  const DeleteRow = (i) => {
    var t = [...state];
    var index = i;
    if (index !== -1) {
      t.splice(index, 1);
      setState(t);
      setdecrypt_msg_dblinking( prev => {
      var prev_arr= [...prev];
      prev_arr.splice(index, 1)
      return [...prev_arr]
    } );
    }
  };

  const checkValidQuery = (x) => {
    x = x.toLowerCase();
    if (x.includes("drop ") || x.includes("delete ")) return false;
    return true;
  };

  function extractComparisonValue(query) {
    // This regex tries to capture values that are:
    // 1. Enclosed in single quotes '...'
    // 2. Enclosed in double quotes "..."
    // 3. Unquoted alphanumeric/underscore values (like numbers or identifiers)
    const regex = /WHERE\s+\w+\s*=\s*(?:'([^']*)'|"([^"]*)"|([a-zA-Z0-9_]+))/i;
    // (?:...) : Non-capturing group for the alternatives
    //   '([^']*)' : Capture group 1 for single-quoted values
    //   "([^"]*)" : Capture group 2 for double-quoted values
    //   ([a-zA-Z0-9_]+) : Capture group 3 for unquoted values

    const match = query.match(regex);

    if (match) {
      // Check which capturing group matched
      return match[1] || match[2] || match[3] || null;
    }
    return null;
  }

  const isMatch = (json,controlId) => {
    let dataC = json["dataclass"]?.replaceAll(".", "_");
    const isMatch = json["id"] === controlId ||
      json.style?.["CustomId"] === controlId ||
      json["control_id"] === controlId ||
      json["dataclass"] === controlId ||
      dataC === controlId;
    return isMatch;
  }

  const comparisonVarAfterLocal = (formState2, controlId, extractId) => {
    if (!formState2 || !formState2.children) return false;

    const stack = [formState2];

    while (stack.length > 0) {
      const current = stack.pop();

      if (!current) continue;

      if (isMatch(current, extractId)) {
        return false;
      }
      if (isMatch(current, controlId)) {
        return true;
      }

      if (current.children) {
        for (let i = current.children.length - 1; i >= 0; i--) {
          const child = current.children[i];

          if (child.subform && child.elem_type === "button") {
            stack.push(child.subform);
          } else if (child.listviewFrameLayoutJson && child.elem_type === "advancelistView") {
            stack.push(child.listviewFrameLayoutJson);
          } else {
            stack.push(child);
          }
        }
      }
    }

    return false;
  };


  const handleInput = async (x, index) => {
    if (checkValidQuery(x)) {
      // if (x.indexOf('"') >= 0) {
      //   setOpen1(true);
      //   setSeverity("error");
      //   setSeverityMessage("Double quotes is not allowed in query");
      // } else {
        let err_obj =  await validateSqlQuery(x, false);
        if(err_obj?.error) {
          showAlertConfirmNotifications({
            showConfirm: "showNotification",
            open: true,
            alertContentKey: `The query contains a syntax error: ${err_obj?.errorMessage} Please review and correct the query.` || "The query contains a syntax error or an invalid WHERE clause. Please review and correct the query.",
            alertType: "error",
          });
          decryptMessage_dblinking(await decryptMessage(state[index]?.Query || ""), index);
          return;
        }
        let extractComparisonVar = extractComparisonValue(x);
        if(extractComparisonVar?.includes('.value')) {
          extractComparisonVar = extractComparisonVar?.split('.value')[0];
          if(comparisonVarAfterLocal(formState2,props?.control_json?.id,extractComparisonVar)) {
              showAlertConfirmNotifications({
                showConfirm: "showNotification",  
                open: true,
                alertContentKey: `You can not use ${extractComparisonVar} here.`,
                alertType: "error",
              });
              return; 
          }
        }
        let temp = [...state];
        if (index > temp.length - 1) {
          let ans = { input: "", controls: [], caching: false };
          temp.push(ans);
        }
        temp[index].Query = await encrypt(x);
        decryptMessage_dblinking(x, index);
        setState(temp);
      // }
    } else {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "DROP_DEL_QUERIES",
      });
    }
  };

  const handleCaching = (index) => {
    let temp = [...state];
    temp[index].Caching = temp[index].Caching ? 0 : 1;
    setState(temp);
  };

  const handleControl = (arr, index) => {
    let temp = [...state];
    if (index > temp.length - 1) {
      let ans = { input: "", controls: [], caching: false };
      temp.push(ans);
    }
    temp[index].Controls = arr;
    setState(temp);
  };

  const ClearAutocomplete = (arr, index) => {
    handleControl(arr, index);
  };

  const [decrypt_msg_dblinking , setdecrypt_msg_dblinking]= React.useState([""]);

  async function decryptMessage_dblinking(query , index){
    // let decypted_str= await decryptMessage(query);

    setdecrypt_msg_dblinking( prev => {
      var prev_arr= [...prev];
      prev_arr[index]= query;
      return [...prev_arr]
    } );
    // const unique_str= `decrypt_msg_dblink_${query}`;
    // window.unique_str = decypted_str;
    // decryptMessage_dblinking( row.Query )
  }

  useEffect(()=>{
    var Query_arr= [];

      state.forEach(async (row, index)=>{
        var row_query = await decryptMessage(row?.Query);
        Query_arr.push(row_query);

        if(state.length === index+1){
          setdecrypt_msg_dblinking(Query_arr);
        }

      });
  

  },[]);


  useEffect(() => {
    arr = [];
    if (openCanvasForSubform === "subform") {
      getControls(subFormStateJson?.children);
    }
    else if(openCanvasForSubform==="showDataAdditonSection"){
      getControls(currentListviewForSubform?.listviewFrameLayoutJson?.children)
    }
    else if (openCanvasForSubform === "advanceListviewFromScratch") {
      getControls(advanceListviewStateJson?.children);
    } else {
      getControls(formState2?.children);
    }
    setControlList((prev) => {
      return arr;
    });
  }, []);

  useEffect(() => {
    if (props.updateHandler) {
      props.updateHandler("DBLinking", state);
    }
  }, [state]);

  function getControls(children) {
    for (let child of children) {
      if (child.children) {
        getControls(child.children);
      } else {
        if (child.elem_type && child.elem_type!=="tile") {
          arr.push({
            value:
              child?.style?.MappingId || child?.style?.CustomId || child?.id,
            label:
              child?.style?.MappingId || child?.style?.CustomId || child?.id,
          });
        }
      }
    }
  }
  return (
    <div className={styles.tableclass}>
      <div className={styles.eventheader}>
        <span>{t(`translation:DB Linking`)}</span>
        <span>
          <span
            className={styles.addrowbtn}
            style={
              translationStyles1
                ? { marginLeft: "20px", marginRight: "unset" }
                : null
            }
            onClick={() => {
              AddRow();
            }}
          >
            {t(`translation:+ Add Link`)}
          </span>
          <span>
            <DeleteIcon
              onClick={() => {
                props.handleDelete(props.name);
              }}
            ></DeleteIcon>
             {
            props?.openedAccordian === props?.name
            ?
            <img
              src={downarrow_svg}
              onClick={()=>props.setopenedAccordian(props?.name) }
              style={{
                width:"24px", 
                height :"24px",
                margin:"0px 0 0 8px" 
              }}
            />
            :
            <img
              onClick={()=>props.setopenedAccordian("")}
              src={uparrow_svg}
              style={{
                width:"24px", 
                height :"24px",
                margin:"0px 0 0 8px" 
              }}
            />
          }
          </span>
        </span>
      </div>
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow style={{ height: "40px" }}>
              <TableCell
                className={styles.tableelementhead}
                style={{
                  whiteSpace: "nowrap",
                  width: "40px",
                  textAlign: "center",
                }}
                align="center"
              >
                {t(`translation:S No.`)}
              </TableCell>
              <TableCell
                className={styles.tableelementhead}
                style={{ width: "322px", textAlign: "center" }}
                align="center"
              >
                {t(`translation:Query`)}
              </TableCell>
              <TableCell
                className={styles.tableelementhead}
                style={{ widht: "277px", textAlign: "center" }}
                align="center"
              >
                {t(`translation:Target Controls`)}
              </TableCell>

              <TableCell
                className={styles.tableelementhead}
                style={{ width: "86px", textAlign: "center" }}
                align="center"
              >
                {" "}
                <Tooltip
                  title={t(`translation:${"Caching Tooltip Content"}`)}
                  classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                  placement={"bottom-start"}
                  arrow
                >
                  <span>{t(`translation:Caching`)}</span>
                </Tooltip>
              </TableCell>

              <TableCell
                className={styles.tableelementhead}
                style={{ width: "41px", color: "transparent" }}
                align="center"
              >
                Empty Header
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {state.map((row, index) => {
              return (
                <TableRow key={`${uuid()}_${index}`} style={{ height: "53px" }}>
                  <TableCell className={styles.tableelement} align="center">
                    {index + 1}
                  </TableCell>
                  <TableCell className={styles.tableelement} align="center">
                    <TextField
                      aria-label="minimum height"
                      multiline
                      minRows={3}
                      inputProps={{ "aria-label": "Enter Query" }}
                      key={`${uuid()}-${index}`}
                      style={{ width: "310px", marginTop: "4px" }}
                      placeholder={t("translation:Enter Query")}
                      onBlur={(e) => handleInput(e.target.value, index)}
                      // onChange={(e) => handleInput(e.target.value, index)}
                      enforceFocus={false}
                      disablePortal={isTaskForm}
                      onFocus={() => console.log("focus")}
                      // value={async () => { return await decryptMessage(row.Query)}}
                      // defaultValue={ async () => await decrypt_msg_dblinking() }
                      defaultValue={ decrypt_msg_dblinking[index] }
                    />
                  </TableCell>
                  <TableCell className={styles.tableelement} align="center">
                    <div style={{ display: "flex" }}>
                      <div className={classes.root} style={{ width: "100%" }}>
                        <Autocomplete
                          className={classes.inputRoot}
                          multiple
                          id="tags-filled"
                          options={controlList.map((option) => option.label)}
                          onChange={(event, value) =>
                            handleControl(value, index)
                          }
                          defaultValue={row.Controls}
                          inputProps={{ "aria-label": "Input Value" }}
                          aria-label="Input Value"
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                variant="outlined"
                                title={option}
                                deleteIcon={
                                  <CloseIcon style={{ width: "15px" }} />
                                }
                                label={option}
                                className={classes.customChip}
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder=""
                              ariaLabel="Input Value"
                              InputProps={{
                                ...params.InputProps,
                                "aria-label": "Input Value", // Set the aria-label here
                              }}
                            />
                          )}
                        />
                      </div>
                      <span
                        className={styles.defaultbtn}
                        style={{ alignSelf: "center", marginRight: "4px" }}
                        onClick={() => {
                          ClearAutocomplete([], index);
                        }}
                      >
                        <img src={remove} alt="remove" />
                      </span>
                    </div>
                  </TableCell>
                  <TableCell className={styles.tableelement} align="center">
                    <ToggleSwitch
                      state={row?.Caching === 1 ? true : false}
                      index={index}
                      handleCaching={handleCaching}
                    ></ToggleSwitch>
                  </TableCell>
                  <TableCell className={styles.tableelement} align="center">
                    <span
                      className={styles.defaultbtn}
                      onClick={() => {
                        DeleteRow(index);
                      }}
                    >
                      <img src={remove} alt="remove" />
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default DBLinking;
